import React from 'react'
import ProfileIcon from "../../../../assets/svgs/ProfileIcon"
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import {Link as RouterLink} from 'react-router-dom';
import useMixpanel from '../../../../hooks/useMixpanel';


const Profile = () => {
    const { track } = useMixpanel();

    const handleProfileClick = () => {
        try {
            track("Profile Clicked")
        } catch (err) {
            // Silently handle tracking errors to prevent app disruption
            console.warn('Profile tracking error:', err);
        }
    }

    return (
        <>
            <Tooltip title="Profile">
                <IconButton color="inherit"
                            component={RouterLink}
                            to={"/Profile"}
                            onClick={handleProfileClick}
                            >
                    {/* onBoarding login  Profile*/}
                    <SvgIcon>
                        <ProfileIcon/>
                    </SvgIcon>
                </IconButton>
            </Tooltip>
        </>
    )
}

export default Profile